import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import LoadingPage from '../../components/LoadingPage'
import { getUser } from '../../../reducers'
import ListClients from './ListClients'
import NewClient from './NewClient'
import DetailsClients from './DetailsClients'
import { db, firestore } from '../../../config/Fire'
import * as Constants from '../../../constants'
import cloneDeep from 'lodash/cloneDeep';
import './styles.css'

const clientPages = {
    LIST_CLIENTS: 'LIST_CLIENTS',
    NEW_CLIENTS: 'NEW_CLIENTS',
    DETAILS_CLIENTS: 'DETAILS_CLIENTS'
}

const ClientsEmployee = props => {
    const [clients, setClients] = useState(null)
    const [clientsPage, setclientsPage] = useState(clientPages.LIST_CLIENTS)
    const [employees, setEmployees] = useState(null)
    const [clientIdToEdit, setClientIdToEdit] = useState(null)

    const getData = () => {
        db.ref(Constants.MAIN_NODES.USERS).once('value')
            .then(usersSnap => {
                const clientsLoaded = {}
                const employeesLoaded = {}
                if (usersSnap.exists()) {
                    usersSnap.forEach(userSnap => {
                        const user = userSnap.val()
                        if (user.userType === Constants.USER_TYPES.CLIENT) {
                            clientsLoaded[user.id] = user
                        }
                        if (user.userType === Constants.USER_TYPES.EMPLOYEE) {
                            employeesLoaded[user.id] = user
                        }
                    })
                }
                setClients(clientsLoaded)
                setEmployees(employeesLoaded)
            })
            .catch(err => {
                console.log('Error getting users: ' + JSON.stringify(err))
            })
        return <LoadingPage/>
    }

    const onNewClientBack = (isNewClient, newClient) => {
        if (isNewClient && newClient) {
            const clientLoaded = cloneDeep(clients)
            clientLoaded[newClient.id] = newClient
            setClients(clientLoaded)
            setclientsPage(clientPages.LIST_CLIENTS)
        } else {
            setclientsPage(clientPages.LIST_CLIENTS)
        }
    }

    const onShowClient = id => {
        if(id && clients && clients[id]) {
            setClientIdToEdit(id)
            setclientsPage(clientPages.DETAILS_CLIENTS)
        }
    }

    const onClientDeleted = id => {
        const clientLoaded = cloneDeep(clients)
        if (id && clientLoaded && clientLoaded[id]) {
            delete clientLoaded[id]
            setClients(clientLoaded)
        }
    }

    const onDetailsClientBack = (editClient, clientToUpdate) => {
        if (editClient && clientToUpdate) {
            const clientLoaded = cloneDeep(clients)
            clientLoaded[clientToUpdate.id] = clientToUpdate
            setClients(clientLoaded)
            setclientsPage(clientPages.LIST_CLIENTS)
        } else {
            setclientsPage(clientPages.LIST_CLIENTS)
        }
    }

    const updateClient = (clientToUpdate) => {
        if (clientToUpdate) {
            const loaded = cloneDeep(clients)
            loaded[clientIdToEdit].name = clientToUpdate.name
            loaded[clientIdToEdit].phone = clientToUpdate.phone
            loaded[clientIdToEdit].email = clientToUpdate.email
            loaded[clientIdToEdit].enabled = clientToUpdate.enabled
            loaded[clientIdToEdit].cuil = clientToUpdate.cuil
            loaded[clientIdToEdit].type = clientToUpdate.type
            setClients(loaded)
            setclientsPage(clientPages.LIST_CLIENTS)
        }
    }

    const updateClientData = (updated, workOrderId, clientOrder) => {
        if (updated && workOrderId && clientOrder) {
            const clientLoaded = cloneDeep(clients)
            clientLoaded[clientOrder.id].workOrderId = workOrderId 
            setClients(clientLoaded)
        }
    }

    const renderWorkPage = page => {
        switch (page) {
            case clientPages.LIST_CLIENTS:
                return <ListClients clients={clients} onClientDeleted={onClientDeleted}
                onShowClient={onShowClient} onNewSelected={() => setclientsPage(clientPages.NEW_CLIENTS)}
                onBack={updateClientData}
                />
            case clientPages.DETAILS_CLIENTS:
                return <DetailsClients clientToEdit={clients[clientIdToEdit]} clients={clients} onBack={onDetailsClientBack} onUpdateClient={updateClient}/>
            case clientPages.NEW_CLIENTS:
                return <NewClient clients={clients} onBack={onNewClientBack}/>
            default:
                return <ListClients onNewSelected={() => setclientsPage(clientPages.NEW_CLIENTS)}/>
        }
    }

    return (
        <div className="outsourcingEmployeeCont">
            {
                props.user ?
                clients !== null ?
                        renderWorkPage(clientsPage)
                        :
                        getData()
                    :
                    <LoadingPage/>
            }
        </div>
    )
}

ClientsEmployee.propTypes = {}

const mapDispatchToPropsActions = dispatch => ({})

const mapStateToProps = state => ({
    user: getUser(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(ClientsEmployee))
